import {
  GetItemMaster,
  PutItemMaster,
  PostItemMaster,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

export interface InspectionItemParams {
  itemId: string;
}

const endPoint = 'inspection-item';

export const getItemMaster = async (
  params?: InspectionItemParams,
): Promise<GetItemMaster> => {
  const queryParams = new URLSearchParams();

  if (params) {
    queryParams.append('itemId', params.itemId);
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const putItemMaster = async (newItem: PutItemMaster): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newItem),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const postItemMaster = async (
  newItem: PostItemMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(newItem),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteItemMaster = async (
  params: InspectionItemParams,
): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('itemId', params.itemId);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
